import {
  InputAdornment,
  TextField,
  Theme,
  createStyles,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { StyledAutoComplete } from "../styles/MaterialGroopTheme";
import React, { useState } from "react";

interface SearchInputProps {
  values: string[];
  onChange: (newValues: string[]) => void;
}

// The main purpose of this class is just to stylize the search field
export const SearchInput = (props: SearchInputProps): JSX.Element => {
  const { values, onChange } = props;
  const isLargeScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("lg"),
  );
  const [inputValue, setInputValue] = useState("");

  const searchStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        "& [class^='MuiOutlinedInput-notchedOutline'], & [class*=' MuiOutlinedInput-notchedOutline']":
          {
            top: "-6px",
          },
        "& [class^='MuiOutlinedInput-root'], & [class*=' MuiOutlinedInput-root']":
          {
            backgroundColor: "#ecf5f6", // app-teal-x-light,
            fieldset: {
              border: `0px;`,
            },
            "&:hover fieldset": {
              borderColor: theme.palette.primary.main,
            },
            input: {
              "&::placeholder": {
                color: theme.palette.common.black,
                opacity: 1,
              },
            },
          },
      },
    }),
  )();

  const lgSearchStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        "& [class^='MuiOutlinedInput-notchedOutline'], & [class*=' MuiOutlinedInput-notchedOutline']":
          {
            top: "-6px",
          },
        "& [class^='MuiOutlinedInput-root'], & [class*=' MuiOutlinedInput-root']":
          {
            fieldset: {
              border: `1px solid ${theme.palette.primary.main};`,
            },
            "&:hover fieldset": {
              borderColor: theme.palette.primary.main,
            },
            input: {
              "&::placeholder": {
                color: theme.palette.primary.main,
                opacity: 1,
              },
            },
          },
      },
    }),
  )();

  return (
    <StyledAutoComplete
      freeSolo
      multiple
      fullWidth
      size="small"
      options={[] as string[]}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
      value={values}
      onChange={(_, newValues) => onChange(newValues.map((v) => v.trim()))}
      renderInput={(params) => (
        <TextField
          {...params}
          classes={isLargeScreen ? lgSearchStyles : searchStyles}
          variant="outlined"
          placeholder="Search"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <InputAdornment position="start">
                  <Search color="primary" />
                </InputAdornment>
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
      ChipProps={{
        color: "primary",
      }}
    />
  );
};
